const CONTROL_SELECTOR = 'input, textarea, select, [contenteditable="true"]';

const signatureFor = element => [
  element.tagName,
  element.getAttribute('type') || '',
  element.getAttribute('name') || '',
  element.getAttribute('placeholder') || '',
  element.getAttribute('aria-label') || '',
].join('|');

const descriptorFor = element => {
  if (!(element instanceof HTMLElement) || !element.matches(CONTROL_SELECTOR)) return null;
  const signature = signatureFor(element);
  const matching = Array.from(document.querySelectorAll(CONTROL_SELECTOR)).filter(control => signatureFor(control) === signature);
  return {
    signature,
    index: matching.indexOf(element),
    start: typeof element.selectionStart === 'number' ? element.selectionStart : null,
    end: typeof element.selectionEnd === 'number' ? element.selectionEnd : null,
  };
};

const findControl = descriptor => {
  if (!descriptor) return null;
  const matching = Array.from(document.querySelectorAll(CONTROL_SELECTOR)).filter(control => signatureFor(control) === descriptor.signature);
  return matching[descriptor.index] || null;
};

let recentInput = null;
let recentInputAt = 0;
let restoreQueued = false;

const remember = event => {
  const descriptor = descriptorFor(event.target);
  if (!descriptor) return;
  recentInput = descriptor;
  recentInputAt = performance.now();
};

document.addEventListener('input', remember, true);
document.addEventListener('change', remember, true);

const observer = new MutationObserver(() => {
  if (!recentInput || performance.now() - recentInputAt > 180 || restoreQueued) return;
  if (document.activeElement && document.activeElement !== document.body && document.activeElement.matches?.(CONTROL_SELECTOR)) return;
  restoreQueued = true;
  requestAnimationFrame(() => {
    restoreQueued = false;
    if (performance.now() - recentInputAt > 220) return;
    const target = findControl(recentInput);
    if (!target) return;
    target.focus({ preventScroll: true });
    if (recentInput.start !== null && typeof target.setSelectionRange === 'function') {
      const length = String(target.value || '').length;
      const start = Math.min(recentInput.start, length);
      const end = Math.min(recentInput.end ?? start, length);
      try { target.setSelectionRange(start, end); } catch {}
    }
  });
});

observer.observe(document.documentElement, { childList: true, subtree: true });
